module.exports = __webpack_public_path__ + "img/menu05a.bf29bade.svg";